import React from "react";

export type PMDirectDebitIconProps = {
  className?: string;
};

export const PMDirectDebitIcon: React.FC<PMDirectDebitIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
    >
      <path
        d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
        fill="white"
      />
      <path
        d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
        stroke="#E4E7EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.591 9.9083V18.4878C17.591 18.4878 12.2574 17.5902 12.2574 14.18C12.2577 11.4602 16.2058 10.2613 17.591 9.9083ZM17.591 9.74824C14.3854 9.53193 7.11684 10.9333 7.11684 14.0003C7.11684 16 10.9657 18.9235 17.2336 19.0003C17.4809 19.0003 24.6011 18.7437 24.4913 11.6155C24.399 5.62841 19.5947 4.57975 18.0584 4.39719V4.03235C24.1831 4.39494 29 7.83038 29 12C29 16.4104 23.6115 20 16.9863 20C10.361 20 5 16.4101 5 12C5 7.58987 10.3607 4 16.9863 4C17.1892 4 17.391 4.00338 17.5913 4.01013L17.591 9.74824Z"
        fill="black"
      />
    </svg>
  );
};
